import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http'

const state: QuestionState = {
  question: {
    form_type: 'textinput',
    answer_options: [],
    raw_form_options: [
      {
        key: "is_required",
        value: true,
      }
    ],
    candidate_profile_key: '',
    internal_annotation: '',
    question_dependencies: [],
    question_negative_rules: []
  },
}

const getters: GetterTree<QuestionState, RootState> = {
}

const actions: ActionTree<QuestionState, RootState> = {
  create({ commit }, config) {
    return http.v1.q.create(config).then(response => {
      commit('SET_QUESTION', response.data.data.bridge)
      commit('QuestionGroup/ADD_LIBRARY_ITEM', response.data.data, { root: true })
      return response
    })
  },
  update({ commit }, { objectId, config }) {
    return http.v1.q.update(objectId, config).then(response => {
      commit('SET_QUESTION', response.data.data)
      commit('QuestionGroup/UPDATE_LIBRARY_ITEM', response.data.data, { root: true })
      return response
    })
  },
  delete({ commit }, objectId) {
    return http.v1.q.delete(objectId).then(() => {
      commit('QuestionGroup/REMOVE_LIBRARY_ITEM', objectId, { root: true })
    })
  },
  sortQuestionDependencies({ commit }, { objectId, config }) {
    return http.v1.q.sortQuestionDependencies(objectId, config).then((response) => {
      commit('SET_QUESTION', response.data.data)
      commit('QuestionGroup/UPDATE_LIBRARY_ITEM', response.data.data, { root: true })
    })
  },
  sortQuestionNegativeRules({ commit }, { objectId, config }) {
    return http.v1.q.sortQuestionNegativeRules(objectId, config).then((response) => {
      commit('SET_QUESTION', response.data.data)
      commit('QuestionGroup/UPDATE_LIBRARY_ITEM', response.data.data, { root: true })
    })
  },
}

const mutations: MutationTree<QuestionState> = {
  SET_QUESTION(state, payload) {
    state.question = Object.assign(state.question, payload)
  },
  ADD_QUESTION_DEPENDENCY(state, payload) {
    if (!state.question.question_dependencies) {
      state.question.question_dependencies = []
    }
    state.question.question_dependencies.unshift(payload)
  },
  UPDATE_QUESTION_DEPENDENCY(state, payload) {
    const index = state.question.question_dependencies.findIndex((questionDependency: Model) => questionDependency.object_id === payload.object_id)
    state.question.question_dependencies[index] = payload
  },
  REMOVE_QUESTION_DEPENDENCY(state, payload) {
    const index = state.question.question_dependencies.findIndex((questionDependency: Model) => questionDependency.object_id === payload)
    if (index > -1) {
      state.question.question_dependencies.splice(index, 1)
    }
  },
  ADD_QUESTION_NEGATIVE_RULE(state, payload) {
    if (!state.question.question_negative_rules) {
      state.question.question_negative_rules = []
    }
    state.question.question_negative_rules.unshift(payload)
  },
  UPDATE_QUESTION_NEGATIVE_RULE(state, payload) {
    const index = state.question.question_negative_rules.findIndex((questionNegativeRule: Model) => questionNegativeRule.object_id === payload.object_id)
    state.question.question_negative_rules[index] = payload
  },
  REMOVE_QUESTION_NEGATIVE_RULE(state, payload) {
    const index = state.question.question_negative_rules.findIndex((questionNegativeRule: Model) => questionNegativeRule.object_id === payload)
    if (index > -1) {
      state.question.question_negative_rules.splice(index, 1)
    }
  },
  CLEAR_STATE(state) {
    state.question = {
      form_type: 'textinput',
      answer_options: [],
      raw_form_options: [],
      question_dependencies: [],
      question_negative_rules: []
    }
  },
}

const anzsco: Module<QuestionState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default anzsco